import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
//Fonts
import "@fontsource/roboto";
import "@fontsource/inter";
//Chakra UI
import { ChakraProvider } from "@chakra-ui/react";

import Router from "./Router";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider>
    <Router />
  </ChakraProvider>
);
